import * as actionTypes from "./actionTypes";
  
  const initialState = {
    loading: false,
    error: null,
    dashboardData: {
      uploadByProjectData: [],
      sourceTypeData: [],
      uploadsOverTimeData: [],
      vendorVsChannelData: [],
      projectUploadVolume: [],
      userOnboardingData: [],
    },
  };
  
  const Dashboard = (state = initialState, action) => {
    switch (action.type) {
      case actionTypes.SET_LOADING:
        return {
            ...state,
            loading: action.payload,
        };
      case actionTypes.FETCH_DASHBOARD_DATA_SUCCESS:
        return {
          ...state,
          loading: false,
          dashboardData: action.payload,
        };
      case actionTypes.FETCH_DASHBOARD_DATA_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default Dashboard;